import React from 'react';
import { Card, Center, Heading, HStack, Spinner, VStack, } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
const PageHeader = ({ title, children, isLoading, loadingTooltip, ...rest }) => {
    const tokens = useTokens();
    const styles = {
        wrapper: {
            background: tokens.Layer01,
            px: '64px',
            boxShadow: '0px 2px 4px 0px rgba(26, 26, 26, 0.20)',
            borderRadius: 0,
        },
    };
    return (React.createElement(Card, { sx: styles.wrapper, ...rest },
        React.createElement(VStack, { alignItems: "flex-start" },
            React.createElement(RenderIf, { condition: !!title },
                React.createElement(HStack, { gap: tokens.Spacing04, mt: tokens.Spacing06, pt: tokens.Spacing04 },
                    React.createElement(Heading, { as: "h1", mt: 0, variant: "primary-lt-3", mb: 0, "aria-label": title, "data-testid": "page_header__title" }, title),
                    React.createElement(RenderIf, { condition: !!isLoading },
                        React.createElement(ConditionalTooltip, { condition: !!loadingTooltip, "aria-label": loadingTooltip, label: loadingTooltip },
                            React.createElement(Center, null,
                                React.createElement(Spinner, { "data-testid": "page_header__loading_spinner" })))))),
            children)));
};
export default PageHeader;
